module.exports = __webpack_public_path__ + "static/img/exploit2.e467e51b.png";